import React from 'react';
import ContactForm from '../../components/ContactForm/ContactForm';
import styles from './Contact.module.css';

const Contact: React.FC = () => {
  return (
    <div className={styles.contact}>
      <div className={styles.container}>
        <section className={styles.section}>
          <h1 className={styles.title}>Contact Us</h1>
          <p className={styles.text}>
            Have a question or need support? Get in touch with us using the form below.
          </p>
          <ContactForm />
        </section>
      </div>
    </div>
  );
};

export default Contact;
